<kt-base-modal [title]=" isLastStepReached ? area?.area_name:  'Forms and Tasks'">
  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div #wizard class="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1">
        <!--begin: Form Wizard Nav -->
        <div class="kt-grid__item kt-wizard-v1__nav-items--clickable">
          <div class="kt-wizard-v1__nav">
            <div class="kt-wizard-v1__nav-items">

              <div *ngIf="forms.length || tasks.length" class="kt-wizard-v1__nav-item " data-ktwizard-type="step"
                data-ktwizard-state="done">
                <div class="kt-wizard-v1__nav-body">

                  <div class="kt-wizard-v1__nav-label">
                    Tasks And Forms
                  </div>
                </div>
              </div>
              <div class="kt-wizard-v1__nav-item " data-ktwizard-type="step" data-ktwizard-state="current">
                <div class="kt-wizard-v1__nav-body">

                  <div class="kt-wizard-v1__nav-label">
                    Verify
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Form Wizard Nav -->

        <div class="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          <!--begin: Form Wizard Form-->
          <div class="kt-form" id="kt_form">
            <div>
              <form>
                <!--begin: Form Wizard Step 1 (client)-->
                <div *ngIf="forms.length || tasks.length" class="kt-wizard-v1__content fix-body-heigt"
                  data-ktwizard-type="step-content" data-ktwizard-state="current">

                  <!-- Form start -->
                  <div class="border rounded my-3">
                    <div class="h5 p-3 mb-0 bg-light">
                      Forms
                    </div>
                    <div class="kt-notification" *ngFor="let form of forms">
                      <a href="javascript:;" class="kt-notification__item" [class.done]="form.filled"
                        (click)="formClickHandler(form)" [attr.title]="'Click to fill the form'">
                        <div class="kt-notification__item-details">
                          <div class="kt-notification__item-title">
                            {{form?.form?.form_name}}
                            <span class="text-danger" *ngIf="form?.area_form_is_required">
                              *</span>
                            <span class="text-danger" *ngIf="form?.area_form_is_required && !form.filled">
                              (Form is required to fill)</span>
                            <span *ngIf="form.filled" class="kt-font-success ms-2">
                              <svg-icon class="svg_icon13x13 d-inline success-config-color" src="assets/media/iq-svg/without_circle/icon_set_3/check_icon.svg"></svg-icon>
                            </span>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <!-- Form end -->

                  <!-- task start -->
                  <div class="border rounded my-3">
                    <div class="h5 p-3 mb-0 bg-light">
                      Tasks
                    </div>
                    <div class="kt-notification" *ngFor="let task of tasks">
                      <a href="javascript:;" class="kt-notification__item" [class.done]="task.filled"
                        (click)="taskGroupClickHandler(task)">
                        <div class="kt-notification__item-details">
                          <div class="kt-notification__item-title">
                            {{task?.task_group?.task_group_name}}
                            <span *ngIf="task.filled" class="kt-font-success ms-2">
                              <svg-icon class="svg_icon13x13 d-inline success-config-color" src="assets/media/iq-svg/without_circle/icon_set_3/check_icon.svg"></svg-icon>
                            </span>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <!-- Task end -->

                  <div class="form-group">
                    <kt-textarea [field]="formConstant.comment" [form]="commentFormGroup"></kt-textarea>
                  </div>

                </div>
                <!--end: Form Wizard Step 1-->

                <!--begin: Form Wizard Step 1 (client)-->
                <div class="kt-wizard-v1__content mt-3 fix-body-heigt" data-ktwizard-type="step-content"
                  data-ktwizard-state="current">
                  <ng-container *ngIf="!loading()">
                    <kt-loader [showLoader]="locationLoading">
                      <google-map *ngIf="mapReady() && location.latitude" class="kt-map d-block w-100" width="100%"
                        height="400px" [center]="{ lat: location.latitude, lng: location.longitude }" [zoom]="18"
                        [options]="{ streetViewControl: false }">
                        <map-marker #m1="mapMarker" [position]="{ lat: location.latitude, lng: location.longitude }"
                          [options]="{ draggable: false, title: 'Your Current Location' }"
                          (mapClick)="openInfoWindow(m1, 'Your Current Location')">
                        </map-marker>
                        <map-marker #m2="mapMarker" *ngIf="shiftInfo"
                          [position]="{ lat: (+shiftInfo.area.area_latitude), lng: (+shiftInfo.area.area_longitude) }"
                          [options]="{ draggable: false }"
                          (mapClick)="openInfoWindow(m2, (shiftInfo?.area?.area_name || '') + ' ' + (shiftInfo?.area?.area_address || ''))">
                        </map-marker>
                        <map-info-window>{{ infoContent }}</map-info-window>
                      </google-map>
                      <div class="h5 text-center bg-light p-3 my-3">
                        Distance From Actual Location {{distanceFromActualLocation | number : '1.2-2'}} KMs
                      </div>
                    </kt-loader>
                  </ng-container>

                </div>
                <!--end: Form Wizard Step 1-->
              </form>
            </div>
            <!--begin: Form Actions -->
            <div class="kt-form__actions modal-footer" [class.justify-content-end]="!forms?.length && !tasks?.length">
              <button *ngIf="forms?.length || tasks?.length" class="btn btn-outline-brand" type="button"
                data-ktwizard-type="action-prev">
                Previous
              </button>
              <!-- <kt-button (buttonClick)="saveClickHandler()" data-ktwizard-type="action-submit"
                [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG">
              </kt-button> -->
              <button class="btn btn-brand" type="button" data-ktwizard-type="action-next">
                Next
              </button>

              <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" *ngIf="isLastStepReached"
                [disabled]="locationLoading || loading()" [loading]="locationLoading || loading()"
                (buttonClick)="saveClickHandler()">
              </kt-button>
            </div>

            <!--end: Form Actions -->
          </div>

          <!--end: Form Wizard Form-->
        </div>

      </div>
    </kt-loader>
  </div>

</kt-base-modal>